/**
 * Остання сторінка модуля в цьому сеансі — стан, до якого повертає прототип v4 page:'module' без openModule (views[модуль], navItem:
 * подання й пункт меню головної таблиці або сторінка модуля — огляд, поради, аналітика, аналітичне подання): простір/модуль → адреса
 * (шлях із рядком запиту). Лише в пам'яті вкладки: після перезавантаження повернення веде на типову сторінку модуля.
 */
const pages = new Map<string, string>();
const keyOf = (ws: string, moduleKey: string): string => `${ws}/${moduleKey}`;

export function rememberModulePage(ws: string, moduleKey: string, url: string): void {
  pages.set(keyOf(ws, moduleKey), url);
}

export function lastModulePage(ws: string, moduleKey: string): string | undefined {
  return pages.get(keyOf(ws, moduleKey));
}
